import * as Sentry from '@sentry/angular';
import {
  isDevMode,
  provideCheckNoChangesConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
  });
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideZonelessChangeDetection(),
    // Dev-only (no-op in optimized builds): throws
    // ExpressionChangedAfterItHasBeenCheckedError when template-bound state
    // changes without notifying Angular (signal/markForCheck/async pipe),
    // and re-checks every second to also catch changes that never scheduled
    // change detection at all.
    ...(isDevMode()
      ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })]
      : []),
    ...appConfig.providers,
  ],
}).catch((err) => console.error(err));
